import React, { FC, useState } from 'react'
import { Box, Stack } from '@mui/material'

import {
  NotionButton,
  NotionTextField,
} from '@/apps/latest/components/portal/notion'

type Props = {
  onSubmit: (name: string, description: string) => void
  onCancel: () => void
  isLoading?: boolean
}

// 医薬品グループの作成フォーム。入力はグループ名+説明のみ。
// 所属薬剤・SOAPテンプレートの整備は作成後に詳細ページ (編集モード) で行う (ADR-0017)。
export const DrugGroupCreateForm: FC<Props> = ({
  onSubmit,
  onCancel,
  isLoading = false,
}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // 送信中の Enter 再送信で二重作成しない (ボタンは disabled だが form submit は通るため)
    if (isLoading) return
    if (!name.trim()) {
      setError('グループ名を入力してください')
      return
    }
    onSubmit(name.trim(), description.trim())
  }

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack gap={2}>
        <NotionTextField
          label="グループ名"
          value={name}
          onChange={(e) => {
            setName(e.target.value)
            setError('')
          }}
          error={!!error}
          helperText={error || undefined}
          fullWidth
          autoFocus
        />
        <NotionTextField
          label="説明"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          rows={2}
          fullWidth
        />
        <Box display="flex" gap={2} justifyContent="flex-end">
          <NotionButton variant="secondary" onClick={onCancel}>
            キャンセル
          </NotionButton>
          <NotionButton type="submit" variant="primary" disabled={isLoading}>
            {isLoading ? '作成中...' : '作成'}
          </NotionButton>
        </Box>
      </Stack>
    </Box>
  )
}
